import { NotificationCenterContract } from '@terra/shared-contracts-notification-center';
import { createTerraOrpcClient } from '@terra/shared-utils';

export const notificationCenterClient = createTerraOrpcClient({
  contract: NotificationCenterContract,
  serviceName: 'orchestrator',
});
